import { paypalPointsPayoutDoneKey, paypalPointsPayoutPendingKey, adminPointsModificationKey, paidOffPlatformKey, pointsAwardKey, pointsCustomKey, } from 'root/src/shared/constants/keys';
export const pointsMinCcv = 50;
export const transactionTypes = [
    pointsAwardKey,
    paypalPointsPayoutPendingKey,
    paypalPointsPayoutDoneKey,
    adminPointsModificationKey,
    paidOffPlatformKey,
    pointsCustomKey,
];
